import React, { memo, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';
import styles from 'Components/PdfFormTemplates/pdfFormTemplates.module.css';
import { deletePdfFormTemplate } from './actions';

interface Props {
  isOpen: boolean;
  template: any;
  onClose: () => void;
}

function DeleteTemplateModal({ isOpen, template, onClose }: Props) {
  const dispatch = useDispatch();
  const [deleting, setDeleting] = useState(false);

  const onConfirm = useCallback(async () => {
    if (!template?.id || deleting) return;
    setDeleting(true);
    try {
      await dispatch(deletePdfFormTemplate(template.id) as any);
    } finally {
      setDeleting(false);
    }
  }, [template, deleting, dispatch]);

  if (!isOpen || !template) return null;

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={styles.modalOverlay} onClick={onClose}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2>Delete Template</h2>
        <p>{`Are you sure you want to delete "${template.name}"? This cannot be undone.`}</p>
        <div className={styles.modalActions}>
          <button type="button" className={styles.btnSecondary} onClick={onClose} disabled={deleting}>
            Cancel
          </button>
          <button type="button" className={styles.btnDanger} onClick={onConfirm} disabled={deleting}>
            {deleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

const DeleteTemplateModalMemo = memo(DeleteTemplateModal, areEqual);
export { DeleteTemplateModalMemo as DeleteTemplateModal };
